import { endpoints } from '../../Constants';
import { authHeader, toQueryStringURL } from '../../Helpers';
import handleResponse from '../helpers';

const shapeModelServices = {
	gateway,
};

function gateway({ req = {}, method }) {
	switch (method) {
		case 'LIST':
			return listShapeModels({
				req,
			});
		case 'VIEW':
			return viewShapeModel({
				req,
			});
		case 'CREATE':
			return createShapeModel({
				req,
			});
		case 'UPDATE':
			return updateShapeModel({
				req,
			});
		case 'PRODUCTS':
			return listShapeModelProducts({
				req,
			});
		case 'SAVE_PRODUCTS':
			return saveShapeModelProducts({
				req,
			});
		case 'UPLOAD_MODEL':
			return uploadShapeModelZip({
				req,
			});
		default:
			break;
	}
	return new Promise(() => {});
}

function getHeaders(isUpload = false) {
	const headers = {
		...authHeader(),
	};
	if (!isUpload) {
		headers['Content-Type'] = 'application/json';
	}
	return headers;
}

function listShapeModels({ req }) {
	const params = {
		...req.params,
	};
	const url = toQueryStringURL(endpoints.SHAPE_MODEL, params);
	const requestOptions = {
		method: 'GET',
		headers: getHeaders(),
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function viewShapeModel({ req }) {
	const params = {
		...req.params,
	};
	const url = toQueryStringURL(endpoints.SHAPE_MODEL, params);
	const requestOptions = {
		method: 'GET',
		headers: getHeaders(),
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function createShapeModel({ req }) {
	const requestOptions = {
		method: 'POST',
		headers: getHeaders(),
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(endpoints.SHAPE_MODEL, requestOptions).then(handleResponse);
}

function updateShapeModel({ req }) {
	const requestOptions = {
		method: 'PATCH',
		headers: getHeaders(),
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(endpoints.SHAPE_MODEL, requestOptions).then(handleResponse);
}

function listShapeModelProducts({ req }) {
	const params = {
		...req.params,
	};
	const url = toQueryStringURL(endpoints.SHAPE_MODEL_PRODUCTS, params);
	const requestOptions = {
		method: 'GET',
		headers: getHeaders(),
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function saveShapeModelProducts({ req }) {
	const requestOptions = {
		method: 'PUT',
		headers: getHeaders(),
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(endpoints.SHAPE_MODEL_PRODUCTS, requestOptions).then(handleResponse);
}

function uploadShapeModelZip({ req }) {
	const formData = new FormData();
	formData.append('shapeModelId', req?.data?.shapeModelId);
	if (req?.data?.modelVersion !== undefined && req?.data?.modelVersion !== '') {
		formData.append('modelVersion', req.data.modelVersion);
	}
	formData.append('file', req?.data?.file);

	const requestOptions = {
		method: 'POST',
		headers: getHeaders(true),
		body: formData,
	};
	return fetch(endpoints.SHAPE_MODEL_UPLOAD, requestOptions).then(handleResponse);
}

export default shapeModelServices;
